import { UserStateType } from 'types/reduxTypes/StateTypes';

export const userDefaultState: UserStateType = {
  user: [],
  isVisible: false,
}

export default null;
